import { menuCountryPartners } from 'utils/menu';
import './Partnerspage.scss';
import { useTranslation } from 'react-i18next';
import { MenuCountryPartner } from 'models/menuModel';
import { useState } from 'react';

export default function PartnersPage() {
  const { t } = useTranslation();
  const [countryPartnerActive, setCountryPartnerActive] = useState<MenuCountryPartner | 'all'>('all');

  const selectCountryPartner = (countryPartner: MenuCountryPartner | 'all') => {
    setCountryPartnerActive(countryPartner);
  }

  return (
    <div className="partners-page">
      <div className="hero-section">
        <div className="container-new">
          <div className="title-partners">
            <h2><b>{t('PARTNERS.TITLE')}</b> <br></br>{t('PARTNERS.TITLE_SUB')}</h2>
            <p className="desc">{t('PARTNERS.TITLE_DESCRIPTION')} <br></br> {t('PARTNERS.TITLE_DESCRIPTION_2')}</p>
          </div>
        </div>
        <div className="wave">
          <div className="content-container">
            <div className="list-country-container">
              <p>
                By Country:
              </p>
              <select id="select-option-country">
                <option onClick={() => selectCountryPartner('all')} selected value="all">All</option>
                {
                  menuCountryPartners.map((country, index) => {
                    return (
                      <option onClick={() => selectCountryPartner(country)} className={typeof countryPartnerActive !== 'string' && countryPartnerActive.name === country.name ? 'active' : ''}>
                        <img src={country.icon} alt={country.name} />
                        {country.name}
                      </option>
                    )
                  })
                }
              </select>
              <ul className="list-country">
                <li onClick={() => selectCountryPartner('all')} className={countryPartnerActive === 'all' ? 'active' : ''}>
                  All
                </li>
                {
                  menuCountryPartners.map((country, index) => {
                    return (
                      <li onClick={() => selectCountryPartner(country)} className={typeof countryPartnerActive !== 'string' && countryPartnerActive.name === country.name ? 'active' : ''}>
                        <img src={country.icon} alt={country.name} />
                        {country.name}
                      </li>
                    )
                  })
                }
              </ul>
            </div>
            <p>Comming soon</p>
          </div>
        </div>
      </div>
    </div>
  )
}